<template>
    <div >
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('Shared.treatmentplan')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="treatmentPlan"
          :ReportName="'TreatmentPlan'"
          :ReportTitle="$t('Shared.treatmentplan')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "treatmentPlanRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          recNo: String,
          patientName: String,
          notesId: String,
          version: String
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                reportParams: [],
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
              this.isParamVisible = false;
            },

            onClickShowReport() {
              this.isParamVisible = false

              this.reportParams = []
              this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo})
              this.reportParams.push({ paramName: 'notesId', paramValue: this.notesId })
              this.reportParams.push({ paramName: 'version', paramValue: this.version })

              console.log(this.reportParams)
              this.isReportVisible = true
              this.$refs.treatmentPlan.buildDocument(this.reportParams)
            }
        },
        
        mounted () {
           if (this.recNo)
              this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
